'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('apps', {
      url: '/apps',
      template: '<apps></apps>'
    });
}



// WEBPACK FOOTER //
// ./client/app/apps/apps.routes.js